import request from '@/blocks/request';

export { receiveCoupon } from '@blocks/coupon/service';

export function getCouponSeries(params) {
  return request({
    useLoading: true,
    url: `/v1/${process.env.VUE_APP_H5_KEY}/coupon/series`,
    params,
  });
}

export function getCouponList(params) {
  return request({
    baseURL: process.env.VUE_APP_PANGKU_API,
    url: `/v1/activity/common/coupons/main`,
    params: {
      actKey: 'dzh191018',
      ...params,
    },
  });
}

export function getNormalCouponList(params) {
  return request({
    baseURL: process.env.VUE_APP_PANGKU_API,
    url: `/v1/activity/common/coupons/normal`,
    params: {
      actKey: 'dzh191018',
      ...params,
    },
  });
}
